import { createApp, watch } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import { i18n, getInitialLocale } from '@/i18n';
import { useAuthStore } from '@/store/auth';
import { useUserNotificationsStore } from '@/store/userNotifications';
import { useUserSitesStore } from '@/store/userSites';
import { initRoleRequestPrompt } from '@/composables/useRoleRequest';

import './style.css';
import { useThemeStore } from '@/store/theme';


async function bootstrap() {
  const app = createApp(App);
  const pinia = createPinia();

  app.use(pinia);
  app.use(i18n);

  const ExpandableTextarea = (await import('@/components/ExpandableTextarea.vue')).default;
  app.component('ExpandableTextarea', ExpandableTextarea);

  const AsyncButton = (await import('@/components/AsyncButton.vue')).default;
  app.component('AsyncButton', AsyncButton);

  // Initialize theme before rendering
  const themeStore = useThemeStore();
  themeStore.initialize();

  const initialLocale = getInitialLocale();
  i18n.global.locale.value = initialLocale;
  document.documentElement.lang = initialLocale;

  const authStore = useAuthStore();
  await authStore.initializeAuth();

  const notificationsStore = useUserNotificationsStore();
  const userSitesStore = useUserSitesStore();

  watch(
    () => authStore.user?.id,
    (userId) => {
      notificationsStore.hydrate(userId);
    },
    { immediate: true },
  );

  watch(
    () => authStore.user?.id,
    (userId) => {
      userSitesStore.hydrate(userId);
    },
    { immediate: true },
  );

  app.use(router);
  initRoleRequestPrompt(router);

  app.mount('#app');
}

bootstrap();
